var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeviasCheckboxOnclick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 3.6875C0.25 2.09597 1.51982 0.8125 3.07882 0.8125H18.4729C20.0296 0.8125 21.3017 2.0961 21.3017 3.6875V19.3125C21.3017 20.9016 20.0295 22.1875 18.4729 22.1875H3.07882C1.51995 22.1875 0.25 20.9017 0.25 19.3125V3.6875ZM2.05911 3.6875V19.3125C2.05911 19.8763 2.51158 20.3438 3.07882 20.3438H18.4729C19.0378 20.3438 19.4926 19.8767 19.4926 19.3125V3.6875C19.4926 3.1209 19.0374 2.65625 18.4729 2.65625H3.07882C2.51199 2.65625 2.05911 3.12131 2.05911 3.6875Z",
    fill: "url(#paint0_linear_0_1)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36317 11.0212L3.36244 11.0205C2.54585 10.1862 2.54585 8.8138 3.36244 7.97949L3.36316 7.97875C4.16778 7.15441 5.4775 7.15441 6.28212 7.97875L10.7383 12.5441L11.275 13.094L11.8117 12.5441L22.7202 1.36826C23.5248 0.543914 24.8345 0.543914 25.6391 1.36826C26.4536 2.20275 26.4536 3.57626 25.6391 4.41076L12.7344 17.6317C11.9298 18.4561 10.6201 18.4561 9.81549 17.6317L3.36317 11.0212Z",
    fill: "#44A59E",
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 21.5517,
    y1: 0.5625,
    x2: 16.0567,
    y2: 25.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeviasCheckboxOnclick);
export default __webpack_public_path__ + "static/media/levias-checkbox-onclick.ba819b933f30c28c4017f5f95c5ab53d.svg";
export { ForwardRef as ReactComponent };